import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { useTheme } from '@mui/material';

export default function IconEyeOpen({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.custom.customDark;

  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M23.5313 11.5434C23.4966 11.4675 22.6753 9.64406 20.8613 7.83C18.4341 5.40656 15.375 4.125 12 4.125C8.625 4.125 5.56594 5.40656 3.14156 7.83C1.3275 9.64406 0.506252 11.4675 0.468752 11.5434C0.405239 11.6874 0.372437 11.8431 0.372437 12.0005C0.372437 12.1579 0.405239 12.3135 0.468752 12.4575C0.503439 12.5344 1.32469 14.3569 3.13969 16.1709C5.56594 18.5944 8.625 19.875 12 19.875C15.375 19.875 18.4341 18.5944 20.8575 16.1709C22.6725 14.3569 23.4938 12.5344 23.5284 12.4575C23.5924 12.3137 23.6257 12.1581 23.6262 12.0008C23.6266 11.8434 23.5943 11.6876 23.5313 11.5434ZM19.2131 14.6372C17.2003 16.6191 14.7741 17.625 12 17.625C9.22594 17.625 6.79969 16.6191 4.78969 14.6362C3.99876 13.8537 3.31841 12.9667 2.7675 12C3.31857 11.0337 3.99891 10.1471 4.78969 9.36469C6.80063 7.38094 9.22594 6.375 12 6.375C14.7741 6.375 17.1994 7.38094 19.2103 9.36469C20.0012 10.147 20.6815 11.0336 21.2325 12C20.6815 12.9666 20.0012 13.8536 19.2103 14.6362L19.2131 14.6372ZM12 7.875C11.1842 7.875 10.3866 8.11693 9.70827 8.57019C9.02992 9.02345 8.50121 9.66769 8.189 10.4214C7.87679 11.1752 7.7951 12.0046 7.95426 12.8047C8.11343 13.6049 8.5063 14.3399 9.08319 14.9168C9.66008 15.4937 10.3951 15.8866 11.1953 16.0457C11.9954 16.2049 12.8248 16.1232 13.5786 15.811C14.3323 15.4988 14.9766 14.9701 15.4298 14.2917C15.8831 13.6134 16.125 12.8158 16.125 12C16.1238 10.9064 15.6888 9.85787 14.9154 9.08455C14.1421 8.31124 13.0936 7.87624 12 7.875ZM12 13.875C11.6292 13.875 11.2667 13.765 10.9583 13.559C10.65 13.353 10.4096 13.0601 10.2677 12.7175C10.1258 12.3749 10.0887 11.9979 10.161 11.6342C10.2334 11.2705 10.412 10.9364 10.6742 10.6742C10.9364 10.412 11.2705 10.2334 11.6342 10.161C11.9979 10.0887 12.3749 10.1258 12.7175 10.2677C13.0601 10.4096 13.353 10.65 13.559 10.9583C13.765 11.2666 13.875 11.6292 13.875 12C13.875 12.4973 13.6775 12.9742 13.3258 13.3258C12.9742 13.6775 12.4973 13.875 12 13.875Z"
      />
    </svg>
  );
}
